import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { maxPriceChange, minPriceChange } from '../../actions';
import { PriceInput as PriceInputComponent } from '../../components/PriceInput';
import { getMinPrice, getMaxPrice } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';

export function PriceInput() {
  const dispatch: TThunkDispatch = useDispatch();
  const [error, setError] = React.useState(false);
  const minPrice = useSelector(getMinPrice);
  const maxPrice = useSelector(getMaxPrice);

  const handlePriceChange = React.useCallback(
    (type: 'minPrice' | 'maxPrice') => (value: number | void) => {
      const handler = {
        minPrice: minPriceChange,
        maxPrice: maxPriceChange,
      };

      // здесь использую as, т.к. компонент NumberInput
      // value требует тип number | null
      // onValueChange принимает number | void
      // жду когда добавят NumberInput в ui-kit после заменю данную реализацию
      dispatch(handler[type](value as number | undefined));
      setQueryParameter(type, value);
    },
    [dispatch],
  );

  const handlePriceBlur = React.useCallback(() => {
    if (!!minPrice && !!maxPrice) {
      setError(minPrice > maxPrice);
    }
  }, [maxPrice, minPrice]);

  return (
    <PriceInputComponent
      minPrice={minPrice}
      maxPrice={maxPrice}
      error={error}
      onChange={handlePriceChange}
      onBlur={handlePriceBlur}
    />
  );
}
